import { TAB_TYPES } from "constants/types/tabTypes";
import SmartSourceContent from "modules/Campaigns/Shared/SmartSourceContent";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import styled from "styled-components";
import { getQueryParam } from "utils";

interface IAssetWithoutCampaignSmartSourcedContent {}

const AssetWithoutCampaignSmartSourcedContent: React.FC<IAssetWithoutCampaignSmartSourcedContent> = (props) => {
  const assetName: string = useSelector((state: RootState) => state.assetWithoutCampaignDetails.assetName);
  const assetKeywords: string[] = useSelector(
    (state: RootState) => state.assetWithoutCampaignDetails.assetKeywords
  );

  const assetId = getQueryParam("asset_id");
  return (
    <Wrapper>
      <SmartSourceContent
        tab={"asset"}
        searchTerms={assetKeywords}
        savedKeywords={assetKeywords}
        title={assetName}
        tabType={TAB_TYPES.ASSET}
        hideHeader={true}
        hideFocusMessage={true}
        isAssetWithoutCampaign={true}
        assetWithoutCampaignName={assetName}
        assetWithoutCampaignId={assetId}
        hideCMS={true}
      />
    </Wrapper>
  );
};

export default AssetWithoutCampaignSmartSourcedContent;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  .message-wrapper {
    margin-bottom: 138px;
  }
  .message-container {
    flex: 1;
    padding: 2% 19%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      color: #424b50;
      font-family:'Roboto Slab', serif;
      font-weight: 600;
      margin-bottom: 5%;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 20px;
      }
    }
  }
`;
